import React from 'react'
import context from '@/context'
import { DropDownList } from '@/components/dropDownList'

export function InstitutionDropdown (props) {
  function onInstitutionChange ({ item }) {
    props.onChange(item)
  }

  return <DropDownList
    {...props}
    dataSource={context.api.institutionService.getMyInstitutions}
    onChange={onInstitutionChange} />
}



// WEBPACK FOOTER //
// ./src/report-app/pages/institution/institutionDropdown.js